import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomSelectMultiple, CustomSelectMultipleProps } from '../../../custom_shared/components';
import { WithInput } from '../../types';
import { useInputHighlighting, useGlobalInputState } from '../../hooks';

export type CustomSelectMultipleWrapperProps = WithInput<CustomSelectMultipleProps>;

const CustomSelectMultipleWrapper: React.FC<CustomSelectMultipleWrapperProps> = (
    props: CustomSelectMultipleWrapperProps
) => {
    const { input, ...rest } = props;

    const [containerRef, setContainerRef] = React.useState<React.RefObject<HTMLDivElement> | null>(null);

    const { containerStyle } = useInputHighlighting(input, containerRef);

    const globalInputState = useGlobalInputState(input, props);

    return (
        <CustomSelectMultiple
            containerStyle={containerStyle}
            filterOption={(text, option) => option?.title && option.title.toLowerCase().includes(text.toLowerCase())}
            getContainerRef={setContainerRef}
            showSearch
            allowClear
            {...rest}
            {...globalInputState}
        />
    );
};

export default observer(CustomSelectMultipleWrapper);
